// STRY0289330 - STEP UP INTRO PAGE

import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';

import {
  Container,
  FormActions,
  FormActionsItem,
  IconComponent,
  IconContainer,
  Trans,
} from '../../../components';
import { TxButton, TxButtonMode } from 'texkit-ui/components';
import { LINK_SERVICES_STEPS } from '.';

import { ReactComponent as IdIcon } from '../../../assets/icons/icon-id.svg';
import { ReactComponent as ShieldIcon } from '../../../assets/icons/icon-shield.svg';

const LinkServiceStepUpIntro = ({ appSlug }) => {
  const dispatch = useDispatch();

  return (
    <div className="link-services step-up-intro">
      <h2 className="page-header">
        <Trans
          file="LinkService"
          id="StepUpIntroTitle"
          fallback="Let’s link your Texas driver license or ID to your account"
        />
      </h2>

      <p className="page-body">
        <Trans
          file="LinkService"
          id="StepUpIntroDescription"
          fallback="Here’s what you’ll need to link your Texas driver license or ID to your account"
        />
      </p>

      <IconContainer>
        <IconComponent
          Icon={IdIcon}
          className="id"
          textFile="CreateAccount"
          textId="LicenseOrIDLinking"
        />
        <IconComponent
          Icon={ShieldIcon}
          className="shield"
          textFile="CreateAccount"
          textId="SocialSecurityNumber"
        />
      </IconContainer>

      <Container className="action-buttons">
        <FormActions className="btn-submit-form" align="left">
          <FormActionsItem>
            <TxButton
              mode={TxButtonMode.Primary}
              onClick={() =>
                dispatch(push(`/link/${LINK_SERVICES_STEPS.ID}/${appSlug}`))
              }
            >
              <Trans
                file="Labels"
                id="StartLinkingYourDLorID"
                fallback="Start linking"
              />
            </TxButton>
          </FormActionsItem>
        </FormActions>
      </Container>
    </div>
  );
};

LinkServiceStepUpIntro.propTypes = {
  appSlug: PropTypes.string.isRequired,
};

const RouteForLinkServiceStepUpIntro = () => (
  <Route
    path="/link/step-up-intro/:appSlug"
    render={({ match }) => (
      <LinkServiceStepUpIntro appSlug={match.params.appSlug} />
    )}
  />
);

export default RouteForLinkServiceStepUpIntro;
